import Modal from "@mui/material/Modal";
import React, { useEffect, useRef } from "react";
import "./Styles/storysetup.css";
import { useAuth } from "../../../../../../../../features/auth/AuthContext";
import { wsURL } from "../../../../../../../../api/api";
import { useNewLessons } from "../NewLessonContext";
import {
  LowerSchoolStoryMode,
  LowerSchoolStoryStatus,
  useLowerSchoolStorySocket,
} from "../LessonWebSocket/useLowerSchoolStorySocket";
import LowerSchoolStoryStage from "./LowerSchoolStoryStage";

const StoryPreview = ({ open = false, onClose, lessonId, lowerSchool = false }) => {
  const { token } = useAuth();
  const { room_id } = useNewLessons();

  // Teacher-side preview of the student experience — same socket and same card
  // the student side uses, only the mode differs. Connects only while the modal
  // is open, so closing it ends the session and a re-open starts again from the
  // intro. `submitStory` is deliberately unused here — submitting belongs to the
  // student side; preview just closes when the story ends.
  const {
    status,
    intro,
    node,
    socketError,
    startStory,
    answerQuestion,
    goBack,
  } = useLowerSchoolStorySocket({
    wsURL,
    token,
    roomId: room_id,
    lessonId,
    mode: LowerSchoolStoryMode.PREVIEW,
    enabled: open && lowerSchool,
  });

  /** Guards the one-shot close when `story_end` arrives. */
  const hasClosedOnEndRef = useRef(false);
  const onCloseRef = useRef(onClose);
  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  // Each open starts a fresh session.
  useEffect(() => {
    if (open) return;
    hasClosedOnEndRef.current = false;
  }, [open]);

  /**
   * Preview mode has no submission — once the last question is answered the
   * backend sends `story_end` and the popup simply closes. The ref keeps this to
   * one call even though `onClose` is a fresh closure on every render.
   */
  useEffect(() => {
    if (status !== LowerSchoolStoryStatus.ENDED) return;
    if (hasClosedOnEndRef.current) return;
    hasClosedOnEndRef.current = true;
    onCloseRef.current?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <Modal open={open} onClose={onClose}>
      <div className="story-preview-container">
        <LowerSchoolStoryStage
          status={status}
          intro={intro}
          node={node}
          socketError={socketError}
          startStory={startStory}
          answerQuestion={answerQuestion}
          goBack={goBack}
          sessionKey={open}
        />
      </div>
    </Modal>
  );
};

export default StoryPreview;
